import React, { useContext, useEffect } from 'react';
import '../styles/MainStyle.css';
import { Context as MainContext } from '../context/MainContext';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Header from '../components/Header';
import Footer from '../components/Footer';
import InLocker from '../components/InLocker';
import Reservation from '../components/Reservation';
import Reserved from '../components/Reserved';
import ThankYou from '../components/ThankYou';
import TimeSpent from '../components/TimeSpent';
import TimeSpentMax from '../components/TimeSpentMax';
import TimeExtension from '../components/TimeExtension';
import Confirmation from '../components/Confirmation';
import ConfirmationsSpent from '../components/ConfirmationsSpent';

import { Typography } from '@material-ui/core';

const MainPage = (props) => {
  const { state, catalog, awbState, setAwbCode, setAwbState } =
    useContext(MainContext);
  useEffect(() => {
    if (props.match.params.awbData) {
      awbState(props.match.params.awbData);
    }
  }, []);
  useEffect(() => {
    if (state.awb) {
      if (state.awb.lastPackageStatus) {
        setAwbState(state.awb.lastPackageStatus.code);
      }
    }
  }, [state.awb]);
  const renderContent = () => {
    if (state.isLoading) {
      return <Spinner className="Loader" animation="grow" variant="danger" />;
    }
    if (state.errorMessage !== null && state.errorMessage !== '') {
      return (
        <div>
          <Typography variant="subtitle1">{state.errorMessage}</Typography>
          <Button
            className="Button"
            onClick={() => awbState(props.match.params.awbData)}
            size="lg"
          >
            REINTENTAR
          </Button>
        </div>
      );
    }
    switch (state.awbState) {
      //Candidate
      case 'CA':
        return (
          <Typography variant="subtitle1">
            ¡Paquete cumple condiciones para ingresarse a locker!
          </Typography>
        );
      //Initial notificaition to customer
      case 'NI':
        return <Reservation />;
      //Customer confirmed visit
      case 'NE':
        return <Reserved />;
      case 'CI':
        return <Reserved />;
      //Time spent(Time Extinguished)
      case 'ET':
        return <TimeSpent />;
      //Reserved for locker
      case 'RL':
        return (
          <Typography variant="subtitle1">
            Tu envío esta siendo ingresado a lockers, te notificaremos en cuanto
            se encuentre disponible
          </Typography>
        );
      //In Locker
      case 'IL':
        return <InLocker />;
      //Moved temporarily to inventory
      case 'MT':
        return <TimeExtension />;
      case 'CI_R':
        return <Reservation />;
      case 'RP':
        return <Reservation />;
      case 'EN':
        return <ThankYou />;
      //Time spent(Time Extinguished)
      case 'ER':
        return <TimeSpent />;
      //Time spent(Time Extinguished)
      case 'EP':
        return <TimeSpentMax />;
      case 'MI':
        return <TimeSpentMax />;
      case 'CO':
        return <Confirmation />;
      case 'MV':
        return <ConfirmationsSpent />;
      default:
        return null;
    }
  };
  return (
    <div className="MainContainer">
      <Header />
      <div className="BodyContainer">{renderContent()}</div>
      <Footer />
    </div>
  );
};

export default MainPage;
